// extracted by mini-css-extract-plugin
module.exports = {"CommentsButton":"ii_a bha_vr bha_iv bha_wf bha_i bha_j bha_q bha_un bha_en bha_ri bha_rj bha_cx","CommentsButton__icon":"ii_b bha_re"};